import React, { useCallback } from 'react';
import styled from 'styled-components';
import type { GiftHistoryResponse } from '../../../../../../api';
import GivelifyBanner from '../../../common/GivelifyBanner';
import { ErrorInfoIcon } from '../../../../../icons';
import { DonationsQueryParams } from '../../../CheckoutWizard/utils';
import { setDonationDetails } from '../../../CheckoutWizard';
import { useNavigate } from 'react-router-dom';
import { useDonee } from '../../../../../../api';
import { Button } from '../../../../../ui';

export type GiftHistoryDetail = GiftHistoryResponse['data'][number] & {
    detailType: 'history';
};

interface GiftFailedBannerProps {
    detail: GiftHistoryDetail;
}

const StyledDiv = styled.div`
    .submit-button {
        margin-bottom: 24px;
    }
`;

const GiftFailedBanner: React.FC<GiftFailedBannerProps> = ({ detail }) => {
    const push = useNavigate();
    const { donee } = useDonee();

    const handleRetry = useCallback(() => {
        if (!donee?.idShort) return;
        const d: DonationsQueryParams[] = detail.envelopes.map((e) => ({
            envelopeId: e.id,
            amount: e.amount,
        }));
        push(setDonationDetails(donee.idShort, d));
    }, [detail.envelopes, donee?.idShort, push]);

    return (
        <StyledDiv>
            <GivelifyBanner
                marginBottom="16px"
                icon={<ErrorInfoIcon color="utilityError" />}
                borderColor="utilityError"
                backgroundColor="utilityErrorLightColor"
                header="Gift Failed"
                body="We weren't able to charge your card"
            />
            <Button
                onClick={handleRetry}
                className="w-full mb-6"
            >
                Try Gift Again
            </Button>
        </StyledDiv>
    );
};

export default GiftFailedBanner;
